<x-loader size="small" loader="circle" [opacity]="0"></x-loader>
